/* global conditionalblocks */
import apiFetch from '@wordpress/api-fetch';
import { deepObjectMerge } from './helpers.js';
const { useState } = wp.element;

export function optionsManager() {
	const [cbData, setCBData] = useState(conditionalblocks);
	const [isSaving, setIsSaving] = useState(false);

	const get = (optionKey, additionalKey) => {
		if (optionKey && additionalKey) {
			return cbData?.[optionKey]?.[additionalKey] ? cbData[optionKey][additionalKey] : false;
		}

		if (optionKey) {
			return cbData?.[optionKey] ? cbData[optionKey] : false;
		}

		return cbData;
	};

	/**
	 * Pass our state to the REST API which will handle the rest.
	 *
	 * @param {*} modified
	 */
	const update = async (modified, deepMerge = true) => {
		setIsSaving(true);
		const updatedState = deepMerge ? deepObjectMerge({ ...cbData }, modified) : { ...cbData, ...modified };

		// Update the current state.
		setCBData(updatedState);

		// Update the options in WordPress.
		try {
			const res = await apiFetch({ path: 'conditional-blocks/v1/update', method: 'POST', data: updatedState });
			if (cbData.developer_mode) {
				console.log('Saving Conditional Blocks Settings', res);
			}
		} catch (error) {
			console.error('Error saving settings:', error);
		} finally {
			setIsSaving(false);
		}

		// Set the state back to the window localized data.
		conditionalblocks = updatedState;

		setIsSaving(false);
	};

	/**
	 * Pass our state to the REST API which will handle the rest.
	 *
	 * @param {*} modified
	 */
	const convertLegacyConditions = async (legacyConditions) => {
		const converted = await apiFetch({ path: 'conditional-blocks/v1/convert-legacy-conditions', method: 'POST', data: { legacyConditions } }).then((res) => res);

		return converted;
	};

	return { data: cbData, get, update, convertLegacyConditions, isDevMode: cbData?.developer_mode, isSaving };
}
